import { motion } from "framer-motion";

export const goTo = (e, hash) => {
  e.preventDefault();
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -84, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="h-px w-10 bg-gold/60" aria-hidden="true" />
    <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">{children}</span>
  </div>
);
